<template>
	<div class="home" v-if="activityData"> 
    <div class="head-title" :style="'font-size:' + (100 / activityData.title.length) + 'vw;'" v-if="activityData.title">{{ activityData.title }}</div>
		<div class="menu" :class="is_top ? 'menu-top' : ''">
			<div class="menu-item" v-for="(item,index) in activityData.types" :key="item.text" @click="onMenu(index)">
				<div :style="'background: ' + (item.hover ? '' : item.color)"></div>
				<span>{{ item.name }}</span>
			</div>
		</div>
		<div class="sort" @click="onSort">
			<div :class="sort === 'asc' ? 'hover' : ''">正序</div>
			<div :class="sort === 'desc' ? 'hover' : ''">倒序</div>
		</div>
		<div v-for="item in list" :key="item.title" v-show="item.list.length > 0" class="time-item">
			<div class="time-head">
				<span v-if="item.subtitle">{{ item.subtitle }}</span>
				<div v-if="item.title">{{ item.title }}</div>
			</div>
			<TimeLine :menu="menu" :list="item.list"></TimeLine>
		</div>
		<div class="foot">封面数字工作室出品</div>
	</div>
</template>

<script>
import CONFIG from '@/utils/config'
import COVERAPP from '@/utils/COVERAPP'
import COVER from '@/utils/COVER'
import UploadComponent from '@/components/Upload'
import DialogComponent from '@/components/Dialog'

import TimeLine from '../components/TimeLine'

import { mapState, mapActions } from 'vuex'
import moment from 'moment'

let aid = '';
let list = [];

export default {
  name: 'home',
  data() {
    return {
      list: [],
      is_top: false,
      sort: 'asc'
    }
	},
	props: ['activityData'],
  computed: {
    ...mapState(['shareData'])
  },
  components: {
		UploadComponent,
		DialogComponent,
		TimeLine,
	},
  filters: {
    date(value) {
      return moment(value).format('M月D日');
    }
	},
	watch: {
		activityData(value, old) {
			console.log(value);
			if (value && !old) {
				this.sort = value.sort;
				this.getList();
			}
		}
	},
  created() {
		aid = '5e7c475fcc067800417b45e9';
  },
  mounted() {
    const _this = this;
		this.share()

    document.body.onscroll = function(res) {
        const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
        const top = document.querySelector('.sort').offsetTop || 0;

        if (scrollTop > top) {
          _this.is_top = true
        } else {
          _this.is_top = false
				}

        const $timeitem = document.querySelectorAll('.time-content');
        let time_index = 0;
        for (let i = 0; i < $timeitem.length; i++) {
						$timeitem[i].style.transform = '';
            if ((scrollTop + window.screen.height / 2) > $timeitem[i].offsetTop) {
                time_index = i;
            }
        }
        $timeitem[time_index].style.transform = 'scale(1.05)';
    }
  },
  methods: {
	...mapActions([
	  'setPageLoadingAsync'
	]),
	share() {
	  COVER.share(this.shareData)		
	},
	getList() {
		COVER.$get('/timeline', {
			aid,
			page: 1,
			rows: 1000
		}).then(res => {
			if (res.errno === 0) {
				list = res.data.list || [];
				this.show();
			}
		});
	},
	show() {
		let subjects = this.activityData.subjects || [];
		const types = this.activityData.types;
		let sort = this.sort;
		subjects.sort((a, b) => {
			if (sort === 'asc') {
				return moment(a.time).unix() - moment(b.time).unix();
			}
			return moment(b.time).unix() - moment(a.time).unix();
		});

		list.sort((a, b) => {
			const a_info = a.info;
			const b_info = b.info;
			if (sort === 'asc') {
				return moment(a_info.time).unix() - moment(b_info.time).unix();
			}
			return moment(b_info.time).unix() - moment(a_info.time).unix();
		});

		for (let i = 0; i < subjects.length; i++) {
			subjects[i].list = [];
			for (let j = 0; j < list.length; j++) {
				const info = list[j].info;
				if (subjects[i].title === info.subject) {
					for (let k = 0; k < types.length; k++) {
						if ((info.type === types[k].name) && !types[k].hover) {
							info.color = types[k].color;
							subjects[i].list.push(info);
						}
					}
				}
			}
		}

		this.list = subjects;
	},
	onMenu(index) {
			const types = this.activityData.types[index];
			types.hover = !types.hover;
			this.$set(this.activityData.types, index, types);
			this.show();
	},
	onSort() {
			let sort = this.sort;
			if (sort === 'asc') {
				sort = 'desc';
			} else {
				sort = 'asc';
			}
			this.sort = sort;
			this.show();
		}
  }
}
</script>

<style lang="less">
@font-face {font-family: 'ysbth';
	src: url('../font/ysbth.TTF') format('truetype'); /* chrome、firefox、opera、Safari, Android, iOS 4.2+*/
}
.home {
	background: #fef3ee url('../img/bg.jpg') no-repeat center top;
	background-size: 100%;
	min-height: 100vh;
	padding: 28vw 0 5vw 0;
	.head-title {
		font-family: 'ysbth';
		color: #3e4a9a;
		text-align: center;
	}
	.sort {
		border: 1px solid #f3a57d;
		padding: 1px;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		text-align: center;
		width: 22vw;
		font-size: 3.2vw;
		color: #f3a57d;
		border-radius: .5vw;
		position: absolute;
		margin: 0 0 0 75vw;
		div {
			width: 50%;
			padding: 1vw 0;
			border-radius: .5vw;
			&.hover {
				background: #f3a57d;
				color: white;
			}
		}
	}
	.time-head {
		color: #3e4a9a;
		font-size: 3.8vw;
		margin: 8vw 0 5vw 8vw;
		font-weight: bold;
		div	{
			background: #3e4a9a;
			font-weight: normal;
			display: table;
			color: white;
			padding: 1vw 3vw;
			font-size: 4.4vw;
			margin-top: 1vw;
			font-family: 'ysbth';
		}
	}
}
.menu {
	display: flex;
	width: 100vw;
	justify-content: space-around;
	background: #fef3ee;
	z-index: 99;
	padding: 2vw 0;
	.menu-item {
		display: flex;
		font-size: 2.8vw;
		align-items: center;
		div {
			width: 2vw;
			height: 2vw;
			border-radius: .3vw;
			margin-right: 1vw;
			flex-shrink: 0;
			background: #bfbfbf;
		}
	}
	&.menu-top {
		position: fixed;
		top: 0;
		left: 0;
	}
}
.foot {
	text-align: center;
	width: 100%;
	padding: 7vw 0 3vw 0;
	font-size: 3.2vw;
	color: #3e4a9a;
}
</style>